import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useScreenInit } from '../useScreenInit.js';
export type AccountMode = 'signin' | 'signup';
interface AccountContextValue {
  isOpen: boolean;
  mode: AccountMode;
  openAccount: (mode?: AccountMode) => void;
  closeAccount: () => void;
  setMode: (mode: AccountMode) => void;
}
const AccountContext = createContext<AccountContextValue | null>(null);
export function AccountProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const screenInit = useScreenInit();
  const [isOpen, setIsOpen] = useState<boolean>(Boolean(screenInit?.accountOpen));
  const [mode, setMode] = useState<AccountMode>(screenInit?.accountMode as AccountMode ?? 'signin');
  const openAccount = useCallback((next: AccountMode = 'signin') => {
    setMode(next);
    setIsOpen(true);
  }, []);
  const closeAccount = useCallback(() => setIsOpen(false), []);
  const value = useMemo<AccountContextValue>(() => ({
    isOpen,
    mode,
    openAccount,
    closeAccount,
    setMode
  }), [isOpen, mode, openAccount, closeAccount]);
  return <AccountContext.Provider value={value} data-id="element-209" data-mp="37zy8mdu10jer">{children}</AccountContext.Provider>;
}
export function useAccount() {
  const ctx = useContext(AccountContext);
  if (!ctx) throw new Error('useAccount must be used within an AccountProvider');
  return ctx;
}